"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("components");
var Section2_module_css_1 = __importDefault(require("./Section2.module.css"));
var SectionItem = (function (_super) {
    __extends(SectionItem, _super);
    function SectionItem(props) {
        return _super.call(this, props) || this;
    }
    SectionItem.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors, identifier = _a.identifier, description = _a.description, model = _a.model;
        return (react_1.default.createElement("div", { className: Section2_module_css_1.default.checkBoxContainer },
            react_1.default.createElement(components_1.CheckBox, { id: identifier, classNameWrap: Section2_module_css_1.default.checkBoxContentWrap, className: "form-user-admissions-rep " + Section2_module_css_1.default.checkboxContent, errors: errors, json_data: json_data, onChange: onChange }),
            react_1.default.createElement("span", null, description)));
    };
    return SectionItem;
}(react_1.Component));
exports.SectionItem = SectionItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VjdGlvbkl0ZW0uanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9pbnRlbGxpdGVjL051cnNpbmdFbnJvbGxtZW50UGFja2V0L3BhcnRzL1NlY3Rpb24yL1NlY3Rpb25JdGVtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLHlDQUEyRDtBQUMzRCw4RUFBMEM7QUFXMUM7SUFBaUMsK0JBQW9CO0lBQ2pELHFCQUFZLEtBQUs7ZUFDYixrQkFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztJQUVELDRCQUFNLEdBQU47UUFDVSxJQUFBLGVBQTBFLEVBQXpFLHdCQUFTLEVBQUUsc0JBQVEsRUFBRSxrQkFBTSxFQUFFLDBCQUFVLEVBQUUsNEJBQVcsRUFBRSxnQkFBbUIsQ0FBQTtRQUVoRixPQUFPLENBQ0gsdUNBQUssU0FBUyxFQUFFLDZCQUFNLENBQUMsaUJBQWlCO1lBQ3BDLDhCQUFDLHFCQUFRLElBQ0wsRUFBRSxFQUFFLFVBQVUsRUFDZCxhQUFhLEVBQUUsNkJBQU0sQ0FBQyxtQkFBbUIsRUFDekMsU0FBUyxFQUFFLDhCQUE0Qiw2QkFBTSxDQUFDLGVBQWlCLEVBQy9ELE1BQU0sRUFBRSxNQUFNLEVBQ2QsU0FBUyxFQUFFLFNBQVMsRUFDcEIsUUFBUSxFQUFFLFFBQVEsR0FDcEI7WUFDRiw0Q0FBTyxXQUFXLENBQVEsQ0FDeEIsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUNMLGtCQUFDO0FBQUQsQ0FBQyxBQXRCRCxDQUFpQyxpQkFBUyxHQXNCekM7QUF0Qlksa0NBQVcifQ==